import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Button.css';

const types = ['button', 'reset', 'submit'];

class Button extends React.Component {

  renderAnchor(classes) {
    const href = this.props.href || '#';
    return (
      <a 
        href={href}
        onClick={this.props.onClick}
        className={classes}
        role="button">
        {this.props.children}
      </a>
    );
  }
  renderButton(classes) {
    return (
      <button
        onClick={this.props.onClick}
        title={this.props.title}
        type={this.props.type || 'button'}
        disabled = {this.props.disabled ? 'disabled' : null}
        className={classes}>
        {this.props.children}
      </button>
    );
  }
  render() {
    const { buttonClass, buttonColor } = this.props;
    const classes = cx(s.Button, s[buttonClass], s[buttonColor]);
    return this[this.props.href ? 'renderAnchor' : 'renderButton'](classes);
  }
}

Button.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  buttonClass: PropTypes.string,
  buttonColor: PropTypes.string,
  title: PropTypes.string,
};

Button.defaultProps = {
  title: ''
}

export default withStyles(s)(Button);



// WEBPACK FOOTER //
// ./src/components/Button/Button.js